<template>
    <div class="jc-steps"
        :class="[`jc-steps-${type}`]"
    ><slot/>
    </div>
</template>

<script>
export default {
  name: 'jc-steps',
  props: {
    value: {},
    type: {
      type: String,
      default: 'arrow' // 现在只实现了箭头步骤条
    }
  },
  data () {
    return {
      steps: [],
      currentValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.currentValue = this.value
      }
    }
  },
  methods: {
    next () {
      let index = this.steps.findIndex(step => step.name === this.value)
      if (index === -1) index = 0
      else if (index < this.steps.length - 1) index++
      else {
        this.$emit('done')
        return
      }
      this.currentValue = this.steps[index].name
      this.$emit('input', this.currentValue)
      this.steps.forEach(step => {
        step.updateStatus()
      })
    }
  }
}
</script>

<style lang="scss">
// 箭头步骤条
.jc-steps-arrow {
    display: flex;
    .jc-steps-item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 72px;
        color: #606060;
        background: #fff;
        font-size: 24px;
        position: relative;
        &::before {
            position: absolute;
            content: '';
            display: block;
            top: 50%;
            left: 0;
            transform: translate(0, -50%);
            width: 0;
            height: 0;
            border-width: 36px 0 36px 28px;
            border-style: solid;
            border-color: transparent transparent transparent #fff;
        }
        &:first-child {
            &::before {
                display: none;
            }
        }
        &.active {
            background: #D8EAFF;
            color: #409bff;
            & + .jc-steps-item {
                &::before {
                    border-left-color: #D8EAFF;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/step/steps.vue